import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

  token: string | undefined;
  time: string | undefined;

  public userData = {
    user_id: '',
    nik: '',
    name: '',
    company_id: '',
    access: ''
  };

  constructor(public router: Router) {
    // @ts-ignore
    this.userData = JSON.parse(localStorage.getItem('userData'));
  }

  // tslint:disable-next-line:typedef
  signupUser(email: string, password: string) {
    // your code for signing up the new user
  }

  signinUser(email: string, password: string) {
    // your code for checking credentials and getting tokens for for signing in user
  }

  logout() {
    localStorage.clear();
  }

  getToken() {
    return localStorage.getItem('token');
  }

  isAuthenticated() {

    if (this.getToken() != null) {
      return this.getToken() != null;
    }
    else {
      this.router.navigateByUrl("/login")
    }
    return false;
  }
}
